export type ModalType = "create" | "update" | "view";

export const MODAL_LABELS_LOOKUP: Record<
    ModalType,
    { title: string; action: string }
> = {
    create: { title: "Criar meta do departamento", action: "Criar" },
    update: { title: "Atualizar meta do departamento", action: "Salvar" },
    view: { title: "Detalhas da meta do departamento", action: "Atualizar" },
};
